<!-- <template>
    <b-modal :static="true" ref="modal-loading" id="modal-loading" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
        <div class="text-center">
            <b-spinner style="width: 3rem; height: 3rem" label="Large Spinner" variant="info"></b-spinner>
        </div>

        <p class="my-4" style="text-align: center">Caricamento dati in corso...</p>
    </b-modal>
</template>

<script>
export default {
    name: "ModalLoading",
    data() {
        return {};
    },
    methods: {
        close() {
            let me = this;
            me.$refs["modal-loading"].hide();
        },
        show() {
            let me = this;
            me.$refs["modal-loading"].show();
        },
    },
};
</script>

<style></style>
 -->
<template>
    <b-modal :static="true" ref="modal-loading" id="modal-loading" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
        <div class="text-center">
            <svg id="loader-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 413.83 418.04" width="60" height="60">
                <ellipse class="punto-superiore" cx="26.35" cy="134.69" rx="26.35" ry="25.4" />
                <path class="arco-superiore" d="M48.95,121.64s36.83-69.72,111.08-88.85c0,0,76.05-27.68,154.8,24.52,0,0,44.55,24.3,69.08,87.97,0,0,2.01,5.17,9.35,6.1,6.05.77,12.04-2.55,14.03-8.32.08-.24.16-.48.23-.73,1.06-3.63.72-7.52-.7-11.02-5.01-12.31-24.22-53.75-67.91-89.3,0,0-66.9-57.83-172.2-37.8,0,0-91.04,15.75-140.36,105.07,0,0,14.46-.56,22.6,12.35Z" />
                <ellipse class="punto-inferiore" cx="387.48" cy="286.95" rx="26.35" ry="25.4" />
                <path class="arco-inferiore" d="M367.18,303.13s-31.92,62.99-106.17,82.12c0,0-76.05,27.67-154.8-24.52,0,0-44.55-24.3-69.08-87.97,0,0-2.01-5.17-9.35-6.1-6.05-.77-12.04,2.55-14.03,8.32-.08.24-.16.48-.23.73-1.06,3.63-.72,7.52.7,11.02,5.01,12.31,24.22,53.75,67.91,89.3,0,0,66.9,57.83,172.2,37.8,0,0,89.16-12.82,138.48-102.14,0,0-16.43,2.5-25.63-8.55Z" />
            </svg>
        </div>
        <p class="my-4" style="text-align: center">Caricamento dati in corso...</p>
    </b-modal>
</template>

<script>
export default {
    name: "ModalLoading",
    data() {
        return {};
    },
    methods: {
        close() {
            let me = this;
            me.$refs["modal-loading"].hide();
        },
        show() {
            let me = this;
            me.$refs["modal-loading"].show();
        },
    },
};
</script>
<style>
#loader-svg {
    animation: rotate 3s linear infinite;
}

.punto-superiore,
.arco-superiore,
.punto-inferiore,
.arco-inferiore {
    fill: #00a3ff;
}
@keyframes rotate {
    0% {
        transform: rotate(360deg);
    }
    100% {
        transform: rotate(0deg);
    }
}
</style>
